import _regenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "C:/Users/lptni/\u5F00\u53D1/dev/project/unbox-server/vue-admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { Message, MessageBox } from 'element-ui';
import util from '@/libs/util.js';
import router from '@/router';
import api from '@/api';
import store from '@/store/index';
import { exRoutes, routes } from '../../../../router/routes';
import { getLeftMenus, getRouters, getTopMenus } from '@/menu';
export default {
  namespaced: true,
  actions: {
    /**
     * 修改平台登录密码。
     * @param dispatch
     * @param password
     * @param newPassWord
     * @returns {Promise<void>}
     */
    editPassWord: function editPassWord(_ref) {
      var _arguments = arguments,
        _this = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var dispatch, _ref2, _ref2$password, password, _ref2$newPassWord, newPassWord;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              dispatch = _ref.dispatch;
              _ref2 = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : {}, _ref2$password = _ref2.password, password = _ref2$password === void 0 ? '' : _ref2$password, _ref2$newPassWord = _ref2.newPassWord, newPassWord = _ref2$newPassWord === void 0 ? '' : _ref2$newPassWord;
              // 调用修改密码接口
              api.UPDATE_USER_PASSWORD({
                password: password,
                newPassWord: newPassWord
              });
              _this.logout({
                confirm: true
              });
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }))();
    },
    /**
     * @description 登录
     * @param {Object} context
     * @param {Object} payload username {String} 用户账号
     * @param {Object} payload password {String} 密码
     * @param {Object} payload route {Object} 登录成功后定向的路由对象 任何 vue-router 支持的格式
     */
    login: function login(_ref3) {
      var _arguments2 = arguments;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var dispatch, _ref4, _ref4$username, username, _ref4$password, password, _ref4$loginType, loginType, res, userInfo, userMenus, setting, menus, routers, topMenus, isLoadRouter;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              dispatch = _ref3.dispatch;
              _ref4 = _arguments2.length > 1 && _arguments2[1] !== undefined ? _arguments2[1] : {}, _ref4$username = _ref4.username, username = _ref4$username === void 0 ? '' : _ref4$username, _ref4$password = _ref4.password, password = _ref4$password === void 0 ? '' : _ref4$password, _ref4$loginType = _ref4.loginType, loginType = _ref4$loginType === void 0 ? '' : _ref4$loginType;
              _context2.n = 1;
              return api.SYS_USER_LOGIN({
                username: username,
                password: password,
                loginType: loginType
              });
            case 1:
              res = _context2.v;
              util.cookies.set('token', res.body.token);
              _context2.n = 2;
              return api.GET_USER_INFO({
                userId: res.body.user.userId,
                loginType: loginType
              });
            case 2:
              userInfo = _context2.v;
              _context2.n = 3;
              return api.GET_USER_MENU_LIST({
                userId: userInfo.id,
                loginType: loginType
              });
            case 3:
              userMenus = _context2.v;
              userInfo.loginType = loginType;
              _context2.n = 4;
              return api.GET_SETTING_INFO({
                id: 1
              });
            case 4:
              setting = _context2.v;
              localStorage.setItem('setting', JSON.stringify(setting.body));
              // 设置 cookie 一定要存 uuid 和 token 两个 cookie
              // 整个系统依赖这两个数据进行校验和存储
              // uuid 是用户身份唯一标识 用户注册的时候确定 并且不可改变 不可重复
              // token 代表用户当前登录状态 建议在网络请求中携带 token
              // 如有必要 token 需要定时更新，默认保存一天
              // 设置 vuex 用户信息
              menus = getLeftMenus(userMenus);
              routers = getRouters(userMenus);
              topMenus = getTopMenus(userMenus);
              localStorage.setItem('userInfo', JSON.stringify(userInfo));
              localStorage.setItem('menus', JSON.stringify(menus));
              localStorage.setItem('routers', JSON.stringify(routers));
              localStorage.setItem('topMenus', JSON.stringify(topMenus));
              localStorage.setItem('authoritys', userInfo.authoritys);

              // 初始化路由以及页面
              isLoadRouter = exRoutes();
              isLoadRouter.forEach(function (res) {
                routes[0].children.push(res);
              });
              router.addRoutes(routes);
              store.commit('d2admin/page/init', isLoadRouter);
              store.commit('d2admin/menu/asideSet', menus);
              store.commit('d2admin/menu/headerSet', topMenus);
              store.commit('d2admin/search/init', topMenus);
              _context2.n = 5;
              return dispatch('d2admin/user/set', {
                name: userInfo.name
              }, {
                root: true
              });
            case 5:
              _context2.n = 6;
              return dispatch('load');
            case 6:
              return _context2.a(2);
          }
        }, _callee2);
      }))();
    },
    /**
     * @description 注销用户并返回登录页面
     * @param {Object} context
     * @param {Object} payload confirm {Boolean} 是否需要确认
     */
    logout: function logout(_ref5) {
      var commit = _ref5.commit,
        dispatch = _ref5.dispatch;
      var _ref6 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        _ref6$confirm = _ref6.confirm,
        confirm = _ref6$confirm === void 0 ? false : _ref6$confirm;
      /**
       * @description 注销
       */
      function logout() {
        return _logout.apply(this, arguments);
      } // 判断是否需要确认
      function _logout() {
        _logout = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
          return _regenerator().w(function (_context3) {
            while (1) switch (_context3.n) {
              case 0:
                // 删除cookie
                util.cookies.remove('token');
                util.cookies.remove('uuid');
                // 清空 vuex 用户信息
                _context3.n = 1;
                return dispatch('d2admin/user/set', {}, {
                  root: true
                });
              case 1:
                // 跳转路由
                router.push({
                  name: 'login'
                });
                localStorage.removeItem('menus');
                localStorage.removeItem('routers');
                localStorage.removeItem('topMenus');
              case 2:
                return _context3.a(2);
            }
          }, _callee3);
        }));
        return _logout.apply(this, arguments);
      }
      if (confirm) {
        commit('d2admin/gray/set', true, {
          root: true
        });
        MessageBox.confirm('确定要退出当前登录吗？', '退出登录提示', {
          type: 'warning'
        }).then(function () {
          commit('d2admin/gray/set', false, {
            root: true
          });
          logout();
        }).catch(function () {
          commit('d2admin/gray/set', false, {
            root: true
          });
          Message({
            message: '取消退出登录操作'
          });
        });
      } else {
        logout();
      }
    },
    /**
     * @description 用户登录后从持久化数据加载一系列的设置
     * @param {Object} context
     */
    load: function load(_ref7) {
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var dispatch;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              dispatch = _ref7.dispatch;
              _context4.n = 1;
              return dispatch('d2admin/user/load', null, {
                root: true
              });
            case 1:
              _context4.n = 2;
              return dispatch('d2admin/theme/load', null, {
                root: true
              });
            case 2:
              _context4.n = 3;
              return dispatch('d2admin/transition/load', null, {
                root: true
              });
            case 3:
              _context4.n = 4;
              return dispatch('d2admin/page/openedLoad', null, {
                root: true
              });
            case 4:
              _context4.n = 5;
              return dispatch('d2admin/menu/asideLoad', null, {
                root: true
              });
            case 5:
              _context4.n = 6;
              return dispatch('d2admin/size/load', null, {
                root: true
              });
            case 6:
              _context4.n = 7;
              return dispatch('d2admin/color/load', null, {
                root: true
              });
            case 7:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    }
  }
};